module.exports = __webpack_public_path__ + "static/media/ET_state_leadership_award.53fd949b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ET_state_leadership_award.webp
// module id = 343
// module chunks = 0